module.exports = {

  factivaToken: (Api) ->
    Api.FactivaToken.get().$promise

}


